<div cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container">
  <div cdkDragHandle class="flex justify-between items-baseline pr-4">
    <h2 mat-dialog-title>Quick Links</h2>
    <button type="button" mat-icon-button class="leading-none" mat-dialog-close><mat-icon>close</mat-icon></button>
  </div>

  <mat-divider></mat-divider>


  @if (isLoading) {
    <div class="loading-spinner">
      <app-sms-spinner [size]="'sm'">
        @if (!isSubmit) {
          <span>Retrieving Quick Links</span>
        } @else {
          Saving Changes
        }
      </app-sms-spinner>
    </div>
  } @else {
    <mat-dialog-content class="p-1">
      @if (isFFIGUser) {
        <mat-nav-list class="ql-list target-leads">
          <a (click)="openSingleSignOn()" class="ql-item p-2 custom-link">Target Leads</a>
        </mat-nav-list>
      }
      <div cdkDropList (cdkDropListDropped)="rearrangeLinks($event)" cdkDropListLockAxis="y" [cdkDropListDisabled]="!isEdit">
        <mat-nav-list class="ql-list">
          @for (link of quickLinks; track link) {
            <div>
              @if (link?.display == '1' || isEdit) {
                <mat-list-item cdkDrag>
                  <div class="flex flex-row items-center justify-between pl-1">
                    @if (isEdit) {
                      <mat-icon matListItemIcon class="drag-handle w-[10%]">menu</mat-icon>
                    }
                    <span class="w-[70%]">
                      @if (!link.isCMSLink) {
                        <a class="ql-item w-[100%] custom-link" [href]="link?.quicklink_url" target="_blank">{{ link.quicklink_title }}</a>
                      } @else {
                        <a class="ql-item w-[100%] custom-link" (click)="callPost($event)">{{ link.quicklink_title }}</a>
                      }
                    </span>
                    @if (isEdit) {
                      <span class="w-[20%] flex justify-end">
                        @if (link?.quicklink_hierarchy_type_name != 'System') {
                          <button mat-icon-button matTooltip="Edit Link" color="primary" (click)="addLink(link)"><mat-icon>edit</mat-icon></button>
                          <button mat-icon-button matTooltip="Delete Link" color="primary" (click)="confirmDelete(link.quicklink_id)"><mat-icon>delete</mat-icon></button>
                        }
                        <button mat-icon-button color="primary" (click)="toggleDisplay(link)">
                          @if (link?.display == '1') {
                            <mat-icon matTooltip="Hide Link">remove</mat-icon>
                          }
                          @if (link?.display == '0') {
                            <mat-icon matTooltip="Show Link">add</mat-icon>
                          }
                        </button>
                      </span>
                    }
                  </div>
                </mat-list-item>
              }
            </div>
          }
        </mat-nav-list>
      </div>
    </mat-dialog-content>
    <div mat-dialog-actions>
      <div class="w-full flex justify-between">
        <span>
          <button mat-raised-button class="ql-cancel" (click)="toggleActionButtons()">
            @if (isEdit) {
              <span>Cancel</span>
            }
            @if (!isEdit) {
              <span>Edit</span>
            }
          </button>
          <button mat-icon-button matTooltip="Add New Link" (click)="addLink()"><mat-icon>add</mat-icon></button>
        </span>
        @if (isEdit) {
          <button mat-flat-button (click)="saveChanges()">Save</button>
        }
      </div>
    </div>
  }


</div>